import {
  useAnalyticsCities,
  useLawAreas,
  useLawSubAreas,
  useLegalServices,
} from './useLawFilters'

export function useSearchFilters() {
  const rawLawAreas = useLawAreas()
  const rawSubAreas = useLawSubAreas()
  const rawCities = useAnalyticsCities()
  const rawLegalServices = useLegalServices()
  const lawAreas = rawLawAreas?.map((lawArea) => ({
    label: lawArea['master_term'],
    value: lawArea['id'],
  }))
  const lawSubAreas = rawSubAreas?.map((subArea) => ({
    label: subArea['master_term'],
    value: subArea['id'],
    area_id: subArea['area_id'],
  }))
  const cities = rawCities?.map((city) => ({
    label: city['city_name'],
    value: city['city_name'],
  }))
  const legalServices = rawLegalServices?.map((legalService) => ({
    label: legalService['master_term'],
    value: legalService['id'],
  }))

  return {
    lawAreas,
    lawSubAreas,
    cities,
    legalServices,
  }
}
